import { defineMessages } from 'react-intl';

export default defineMessages({
  composerPlaceholder: {
    id: 'app.features.aiCompanion.composerPlaceholder',
    defaultMessage: 'Ask the Companion…',
  },
  composerAttach: {
    id: 'app.features.aiCompanion.composerAttach',
    defaultMessage: 'Attach files',
  },
  composerAttachLimit: {
    id: 'app.features.aiCompanion.composerAttachLimit',
    defaultMessage:
      'Attach up to {count} files, {totalMb} MB in total: images up to {imageMb} MB, documents up to {documentMb} MB.',
  },
  composerRemoveAttachment: {
    id: 'app.features.aiCompanion.composerRemoveAttachment',
    defaultMessage: 'Remove {name}',
  },
  composerSubmit: {
    id: 'app.features.aiCompanion.composerSubmit',
    defaultMessage: 'Send message',
  },
  composerStop: {
    id: 'app.features.aiCompanion.composerStop',
    defaultMessage: 'Stop responding',
  },
  copyAnswer: {
    id: 'app.features.aiCompanion.copyAnswer',
    defaultMessage: 'Copy answer',
  },
  answerCopied: {
    id: 'app.features.aiCompanion.answerCopied',
    defaultMessage: 'Answer copied',
  },
  elapsedSeconds: {
    id: 'app.features.aiCompanion.elapsedSeconds',
    defaultMessage: '· {seconds}s',
  },
  thoughtProcess: {
    id: 'app.features.aiCompanion.thoughtProcess',
    defaultMessage: 'Thought process',
  },
  thoughtForSeconds: {
    id: 'app.features.aiCompanion.thoughtForSeconds',
    defaultMessage: 'Thought for {duration}',
  },
  download: {
    id: 'app.features.aiCompanion.download',
    defaultMessage: 'Download',
  },
  newChat: {
    id: 'app.features.aiCompanion.newChat',
    defaultMessage: 'New chat',
  },
  showHistory: {
    id: 'app.features.aiCompanion.showHistory',
    defaultMessage: 'Show chat history',
  },
  hideHistory: {
    id: 'app.features.aiCompanion.hideHistory',
    defaultMessage: 'Hide chat history',
  },
  threadSearch: {
    id: 'app.features.aiCompanion.threadSearch',
    defaultMessage: 'Search chats',
  },
  threadUntitled: {
    id: 'app.features.aiCompanion.threadUntitled',
    defaultMessage: 'Untitled chat',
  },
  threadRename: {
    id: 'app.features.aiCompanion.threadRename',
    defaultMessage: 'Rename chat',
  },
  threadDelete: {
    id: 'app.features.aiCompanion.threadDelete',
    defaultMessage: 'Delete',
  },
  threadDeleteTitle: {
    id: 'app.features.aiCompanion.threadDeleteTitle',
    defaultMessage: 'Delete chat',
  },
  threadDeleteConfirm: {
    id: 'app.features.aiCompanion.threadDeleteConfirm',
    defaultMessage: '"{name}" will be deleted permanently.',
  },
  threadDeleteCancel: {
    id: 'app.features.aiCompanion.threadDeleteCancel',
    defaultMessage: 'Cancel',
  },
  threadsEmpty: {
    id: 'app.features.aiCompanion.threadsEmpty',
    defaultMessage: 'No chats yet.',
  },
  threadsLoadFailed: {
    id: 'app.features.aiCompanion.threadsLoadFailed',
    defaultMessage: "Your chats couldn't be loaded.",
  },
  threadsRetry: {
    id: 'app.features.aiCompanion.threadsRetry',
    defaultMessage: 'Retry',
  },
  voiceRecord: {
    id: 'app.features.aiCompanion.voiceRecord',
    defaultMessage: 'Record a message',
  },
  voiceDiscard: {
    id: 'app.features.aiCompanion.voiceDiscard',
    defaultMessage: 'Discard recording',
  },
  voiceAccept: {
    id: 'app.features.aiCompanion.voiceAccept',
    defaultMessage: 'Use recording',
  },
  voiceNoSpeech: {
    id: 'app.features.aiCompanion.voiceNoSpeech',
    defaultMessage: 'No speech detected',
  },
  voiceUnavailable: {
    id: 'app.features.aiCompanion.voiceUnavailable',
    defaultMessage: 'Microphone unavailable',
  },
  toolPending: {
    id: 'app.features.aiCompanion.toolPending',
    defaultMessage: 'Pending',
  },
  toolRunning: {
    id: 'app.features.aiCompanion.toolRunning',
    defaultMessage: 'Running',
  },
  toolCompleted: {
    id: 'app.features.aiCompanion.toolCompleted',
    defaultMessage: 'Completed',
  },
  toolFailed: {
    id: 'app.features.aiCompanion.toolFailed',
    defaultMessage: 'Failed',
  },
});
